module.exports = __webpack_public_path__ + "img/logo-full.a518c178.svg";